import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import type { ButtonVariant } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { NavBar } from 'apps/auth/components/common/Layout/NavBar/NavBar';
import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_CLOUD } from 'apps/auth/constants/UrlConstants';

import styles from './PromoScreen.module.css';

interface PromoScreenProps {
    topButtonCaption?: string;
    onTopButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
    mainImageTopText?: string;
    mainImageBottomText?: string;
    text?: React.ReactNode;
    bottomButtonCaption?: string;
    href?: string;
    onBottomButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
    variant?: ButtonVariant;
    bankLogos?: Array<string>;
}

const BACKGROUND_URL = `${URL_CLOUD}/promo_fee_countries_new/promo-fee-countries-default-background`;
const backgroundStyle = {
    '--promo-screen-bg': `url('${BACKGROUND_URL}.webp')`,
    '--promo-screen-bg-2x': `url('${BACKGROUND_URL}@2x.webp')`,
} as React.CSSProperties;

const PromoScreen: React.FC<PromoScreenProps> = (props) => {
    return (
        <div className={styles.promoScreenPopup}>
            <div className={styles.promoScreenContainer} style={backgroundStyle}>
                {props.topButtonCaption && (
                    <NavBar align="right" insideStories>
                        <Button caption={props.topButtonCaption} variant="glassTertiary" size="tight" type="button" onClick={props.onTopButtonClick} />
                    </NavBar>
                )}
                <div className={styles.promoScreenContent}>
                    <div>
                        <Text variant="div" size={'header'} color="white_base" textAlign="center" indent={'16px'}>
                            {props.mainImageTopText}
                        </Text>
                        <div className={styles.promoRateWrapper}>
                            <div className={styles.promoRate}>
                                <DangerouslyHtml
                                    dangerouslyHtml={props.mainImageBottomText}
                                    type={'text'}
                                    variant="div"
                                    size={'display2'}
                                    color="black_base"
                                    textAlign="center"
                                />
                            </div>
                        </div>
                        <Text variant="div" size={'main'} color="whiteRgba72" textAlign="center">
                            {props.text}
                        </Text>
                    </div>

                    <div className={styles.bankIcons}>
                        {props.bankLogos
                            ? props.bankLogos.map((logo, index) => (
                                  <picture key={index}>
                                      <source srcSet={`${logo ?? ''} 1x, ${logo ?? ''} 2x`} />
                                      <img src={logo} alt="bank" />
                                  </picture>
                              ))
                            : null}
                    </div>
                </div>
                <FixedBottomPanel isRightAligned insideStories>
                    <Button
                        caption={props.bottomButtonCaption}
                        variant={props.variant}
                        type="link"
                        href={props.href}
                        onClick={props.onBottomButtonClick}
                        mobileFullwidth
                    />
                </FixedBottomPanel>
            </div>
        </div>
    );
};

export default PromoScreen;
